
import { useState } from 'react';
import PortfolioView from '../../components/Stylist/PortfolioView';

const PortfolioPage = () => {
  const [viewingPortfolio, setViewingPortfolio] = useState(null);

  // Sample gallery images
  const gallery = [
    { id: 1, category: 'Hair', url: 'https://images.unsplash.com/photo-1519699047748-de8e457a634e', title: 'Elegant Updo' },
    { id: 2, category: 'Hair', url: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f', title: 'Modern Cut' },
    { id: 3, category: 'Makeup', url: 'https://images.unsplash.com/photo-1531219572328-a0171d44432a', title: 'Bridal Makeup' },
    { id: 4, category: 'Nails', url: 'https://images.unsplash.com/photo-1604658243847-17375af581fa', title: 'French Manicure' },
    { id: 5, category: 'Hair', url: 'https://images.unsplash.com/photo-1492106087820-71f1a00d2b11', title: 'Bridal Style' },
    { id: 6, category: 'Makeup', url: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9', title: 'Evening Glam' },
  ];

  const [activeCategory, setActiveCategory] = useState('All');

  const categories = ['All', 'Hair', 'Makeup', 'Nails'];

  const filteredGallery = activeCategory === 'All' 
    ? gallery 
    : gallery.filter(item => item.category === activeCategory);

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h2 className="text-2xl font-bold mb-8">Our Portfolio</h2>
        
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition ${
                activeCategory === category 
                  ? 'bg-purple-600 text-white' 
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredGallery.map(item => (
            <div 
              key={item.id} 
              className="bg-gray-800 rounded-xl overflow-hidden hover:shadow-lg transition cursor-pointer"
              onClick={() => setViewingPortfolio({ name: 'Salon Portfolio', ...item })}
            >
              <div className="h-64 overflow-hidden">
                <img
                  src={item.url}
                  alt={item.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4">
                <h3 className="font-semibold">{item.title}</h3>
                <p className="text-sm text-gray-400">{item.category}</p>
              </div>
            </div>
          ))}
        </div>
        
        {viewingPortfolio && (
          <PortfolioView 
            stylist={viewingPortfolio} 
            onClose={() => setViewingPortfolio(null)} 
          />
        )}
      </div>
    </div>
  );
};

export default PortfolioPage;